{
  "welcome": {
    "title": "خوش آمدید، {{name}}",
    "title_noName": "به Rhemn خوش آمدید",
    "body": "هر چیزی که می‌درخشد، نشانتان می‌دهد چه کاری انجام می‌دهد. به هر ترتیبی و هر وقت خواستید، کاوش کنید.",
    "start": "شروع کاوش",
    "later": "الان نه"
  },
  "card": {
    "tryIt": "امتحان کنید",
    "takeALook": "نگاهی بیندازید",
    "pro": "بخشی از Rhemn Pro",
    "close_aria": "بستن"
  },
  "pill": {
    "progress": "{{count}} از {{total}} کاوش شد",
    "progress_short": "{{count}} از {{total}}",
    "done": "تمام",
    "done_aria": "پایان کاوش",
    "complete": "همه کاوش شد"
  },
  "sr": {
    "started": "حالت کاوش روشن است. دکمه‌ها پیش از اجرا نشان می‌دهند چه کاری انجام می‌دهند.",
    "hint": "حالت کاوش. ابتدا نشان می‌دهد این چه می‌کند.",
    "ended": "حالت کاوش خاموش است."
  },
  "settings": {
    "row": "Rhemn چگونه کار می‌کند",
    "row_sub": "نگاهی کوتاه به هر بخش",
    "row_aria": "Rhemn چگونه کار می‌کند: دوباره برنامه را کاوش کنید",
    "helpCaption": "راهنما"
  },
  "steps": {
    "intention": {
      "title": "نیت امروز",
      "body": "مهم‌ترین کار امروز را بنویسید و وقتی انجام شد، تیکش را بزنید."
    },
    "now": {
      "title": "روز شما، بر اساس نماز",
      "body": "Rhemn روزتان را با هر نماز تقسیم می‌کند. این بخش زمان باقی تا نماز بعدی و برنامه‌تان برای آن را نشان می‌دهد."
    },
    "verse": {
      "title": "بینش‌های آیه",
      "body": "درباره آیه امروز سؤال بپرسید، تفسیری کوتاه بخوانید و آیه‌هایی با همان موضوع پیدا کنید."
    },
    "qibla": {
      "title": "قبله",
      "body_chrome": "جهت کعبه از جایی که هستید، به‌صورت زاویه نسبت به شمال.",
      "body_ios": "از جایی که هستید به سوی کعبه اشاره می‌کند. قطب‌نمای زنده را روشن کنید تا با چرخش شما همراه شود."
    },
    "prayer": {
      "title": "اوقات نماز",
      "body_chrome": "اوقات پنج نماز امروز برای جایی که هستید. روش محاسبه‌ای را که مسجدتان به کار می‌برد انتخاب کنید.",
      "body_ios": "نماز بعدی‌تان در یک نگاه. آن را باز کنید تا هر پنج وقت و یادآوری برای هر کدام را ببینید."
    },
    "tasks": {
      "title": "وظایف",
      "body": "کارهایتان را در فهرست‌ها نگه دارید و به هر کدام جایی میان نمازها بدهید."
    },
    "notes": {
      "title": "یادداشت‌ها",
      "body_chrome": "بنویسید، یا فقط حرف بزنید. Rhemn یادداشت‌های صوتی و جلسه‌هایتان را به متن تبدیل و سپس خلاصه می‌کند.",
      "body_ios": "بنویسید، یا فقط حرف بزنید. Rhemn گفته‌هایتان را به یادداشت‌هایی مرتب و خلاصه تبدیل می‌کند."
    },
    "profile": {
      "title_chrome": "نمایه شما",
      "body_chrome": "تنظیمات حساب و حریم خصوصی شما. برای کاوش دوباره Rhemn به اینجا برگردید.",
      "title_ios": "بیشتر",
      "body_ios": "آیه‌های ذخیره‌شده، قبله و تنظیمات حساب شما. از اینجا می‌توانید Rhemn را دوباره کاوش کنید."
    }
  }
}
